import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: 35,
  }
}));

const Header = React.memo((props) => {
  const { className, title, subtitle, ...rest } = props;

  const classes = useStyles();

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Grid
        alignItems="flex-end"
        container
        justifyContent="space-between"
        spacing={1}
        className={classes.title}
      >
        <Grid item>
          {title && (
            <Typography
              component="h2"
              gutterBottom
              paragraph
              variant="overline"
            >
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography component="h1" variant="h3">
              {subtitle}
            </Typography>
          )}
        </Grid>
      </Grid>
    </div>
  );
});

Header.propTypes = {
  className: PropTypes.string,
};

export default Header;
